import { ReactElement, forwardRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CLICK_TRACKING_EVENT, DATA_OBJECTS } from 'const/analytics'
import { FAR_MAGNIFYING_GLASS, FAR_TIMES } from 'const/icons'
import i18n from 'strings/i18n'
import {
  ClearButton,
  SearchIcon,
  SearchInput,
  SearchInputWrapper
} from './subcomponents'

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
  onFocus: () => void
  isOpen: boolean
  isExpanded: boolean
}

const SearchBar = forwardRef<HTMLInputElement, SearchBarProps>(
  ({ value, onChange, onFocus, isOpen, isExpanded }, ref): ReactElement => {
    return (
      <SearchInputWrapper>
        <SearchInput
          ref={ref}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          placeholder={`${i18n({ search: 'placeholder' })}`}
          role="combobox"
          aria-expanded={isOpen}
          aria-autocomplete="list"
          aria-controls="search-results-listbox"
          aria-label={`${i18n({ search: 'ariaLabel' })}`}
          $isExpanded={isExpanded}
          data-expanded={isExpanded}
          data-test="search-input"
          data-cy="search-input"
        />
        {value && (
          <ClearButton
            onClick={() => onChange('')}
            aria-label={`${i18n({ search: 'clear' })}`}
            data-analytics={CLICK_TRACKING_EVENT}
            data-reason="x button"
            data-test="search-clear"
            data-type="search bar"
            data-object={DATA_OBJECTS.BUTTON}
          >
            <FontAwesomeIcon icon={FAR_TIMES} />
          </ClearButton>
        )}
        <SearchIcon aria-hidden>
          <FontAwesomeIcon icon={FAR_MAGNIFYING_GLASS} size="lg" />
        </SearchIcon>
      </SearchInputWrapper>
    )
  }
)

SearchBar.displayName = 'SearchBar'

export default SearchBar
